export default __webpack_public_path__ + "static/media/459.a8bb108c.jpg";